var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgVat = function SvgVat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.177 14.903h4.852c2.775 0 3.465-.69 3.465-3.465-.96 0-1.732-.78-1.732-1.733 0-.96.772-1.74 1.732-1.74v-.69c0-2.775-.69-3.465-3.465-3.465H8.244v5.093",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.245 12.652v2.25H6.168c-1.11 0-1.763-.757-2.483-2.497l-.135-.337c.908-.36 1.35-1.41.968-2.318a1.777 1.777 0 0 0-2.325-.967l-.128-.323C.985 5.82 1.36 4.897 4 3.81L5.98 3l2.265 5.49v1.912M6.122 14.903h-.128",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgVat;